import Axios from "axios";
import config from '../../../config';

export interface IQueryParams{
    weed? : string,
    year?: number,
    genus? : string,
    herbicide? : string,
    actionMechanism? : string,
    multipleMechanism? :string,
    species? :Array<string>,
    cities? :Array<Number>,
    state?: number,
    weedResponse?: string
}

export const fetchListaOcorrencias = async (parameters: IQueryParams) => {
    try {
        const response = await Axios.post(config.url_lista_ocorrencias, parameters);
        return response.data;
    } catch (e) {
        console.error("Erro ao ler a lista de ocorrências " + e);
        return null;
    }
}







